import React from "react";
import TextButton from "../Button/TextButton/TextButton";
import Input from "../Input/Input";
import InputForm from "../InputForm/InputForm";
import InputFormHeading from "../InputForm/InputFormHeading";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../store/user/userActions";
import {
  selectLoginError,
  selectLoginStart,
} from "../../store/user/userSelector";

export default function Login() {
  const state = useSelector((state) => state);
  let loginError = selectLoginError(state);
  let loginStart = selectLoginStart(state);
  const dispatch = useDispatch();
  const [emailOrPhone, setEmailOrPhone] = useState(null);
  const [password, setPassword] = useState(null);

  const handelFormSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(emailOrPhone, password));
    // dispatc login action
    // handel err
  };
  return (
    <div className="login-comp">
      <div className="user-form ">
        <InputForm className="login-form" onSubmit={handelFormSubmit}>
          <InputFormHeading
            heading="تسجيل الدخول"
            className="login-form-heading text-center"
          />
          <Input
            focused={emailOrPhone}
            type="email"
            placeholder="البريد الالكتروني"
            required
            disabled={loginStart}
            className="login-form-input text-right"
            onChange={(e) => setEmailOrPhone(e.target.value)}
          />
          <Input
            className='text-right'
            focused={password}
            type="password"
            placeholder="كلمة السر"
            required
            disabled={loginStart}
            onChange={(e) => setPassword(e.target.value)}
          />
          {loginError && <p className="login-error-message">{loginError}</p>}
          <TextButton
            type="submit"
            bcBlue
            rounded
            disabled={!emailOrPhone || !password || loginStart}
            loading={loginStart}
            className="flow-login-btn"
          >
            التسجيل
          </TextButton>
          <div className="signup-option justify-center">
            <Link to="/flow/signup" className="default-link">
              أنشئ حساب
            </Link>
            &nbsp;&nbsp;
            <p className="signup-option-text">ليس لديك حساب؟</p>
          </div>
        </InputForm>
      </div>
    </div>
  );
}
